export default __webpack_public_path__ + "images/passed_practice_exam.4d894e356efb915770c277c826da9400.svg";